import "./ComingSoonPage.css";

/** 独立站：目录中不存在对应产品实例 */
export function ComingSoonPage(): JSX.Element {
  return (
    <div className="standalone-coming-soon" role="status">
      <p className="standalone-coming-soon__text">即将上线</p>
    </div>
  );
}
